import { useEffect, useMemo, useState } from 'react';
export function useMediaQuery(query) {
    var result = useMemo(function () { return window.matchMedia(query); }, [query]);
    var _a = useState(result.matches), matches = _a[0], setMatches = _a[1];
    useEffect(function () {
        var update = function (e) {
            setMatches(e.matches);
        };
        if (typeof result.addEventListener === 'function') {
            result.addEventListener('change', update);
            return function () {
                result.removeEventListener('change', update);
            };
        }
        else if (typeof result.addListener === 'function') {
            result.addListener(update);
            return function () {
                result.removeListener(update);
            };
        }
    }, [result]);
    return matches;
}
//# sourceMappingURL=useMediaQuery.js.map